module.exports = __webpack_public_path__ + "img/q3.a2ee0982.png";